import EditProfileForm from "@/app/shared/orders/customer-profile/edit-profile/edit-profile-form";
import { useModal } from "@/app/shared/modal-views/use-modal";
import cn from "@/utils/class-names";
import { PiNotePencil } from "react-icons/pi";
import { Button } from "rizzui";

interface EditProfileProps {
    className?: string;
}

export default function EditProfileButton({ className }: EditProfileProps) {
    const { openModal } = useModal();
    return (
        <Button
            variant="outline"
            className={cn("gap-2", className)}
            onClick={() =>
                openModal({
                    view: <EditProfileForm />,
                    customSize: "850px",
                })
            }
        >
            <PiNotePencil className="h-5 w-5" /> Edit Profile
        </Button>
    );
}
